
import Vue, { VNode } from 'vue'

export default Vue.component('respondeco-stepper-container', {
  functional: true,

  props: {
    activeIndex: {
      default: 0,
      required: true,
      type: Number,
    },
  },

  render(createElement, context): VNode {
    return context.slots().default[context.props.activeIndex]
  },
})
